import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import MainAnimation from "../components/MainScreen/MainAnimation";
import SwipeBlock from "../components/MainScreen/SwipeBlock";
import ScoreBlock from "../components/MainScreen/ScoreBlock";
import ScreenWrapper from "../components/Wrappers/ScreenWrapper";
import {useAppSelector} from "../hooks/hooks";
import Loader from "../components/Loader";
import WebApp from "@twa-dev/sdk";
import BetaBlock from "../components/MainScreen/BetaBlock";
import BetaBadge from "../components/MainScreen/BetaBadge";

const MainScreen: React.FC = () => {
    const backgroundRef = React.useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(0);
    const [loading, setLoading] = useState(true);
    const [modalToggle, setModalToggle] = useState(false);
    const {data: swipeStateData, status: swipeStateStatus} = useAppSelector((state) => state.swipe)
    const userData = useAppSelector((state) => state.user.data)

    useEffect(() => {
        WebApp.HapticFeedback.impactOccurred('soft');
        if(backgroundRef.current) {
            setHeight(backgroundRef.current.clientHeight / 2)
        }
    }, []);

    useEffect(() => {
        if (swipeStateStatus === 'fulfilled' || swipeStateStatus === 'fulfilled_send') {
            setLoading(false);
        }
    }, [swipeStateStatus]);

    const handleToggle = () => {
        setModalToggle(!modalToggle);
    }

    return (
        <ScreenWrapper>
            <Loader loading={loading} duration={300}>
            <MainAnimation ref={backgroundRef} />
            <BodyWrapper>
                <Body>
                    <BetaBadge handleToggle={handleToggle}/>
                    <BetaBlock modalToggle={modalToggle} handleToggle={handleToggle}/>
                    <SwipeBlock animationHeight={height}/>
                    <ScoreBlock points={userData.points} day={swipeStateData.day} season={swipeStateData.season}/>
                </Body>
            </BodyWrapper>
            </Loader>
        </ScreenWrapper>
    );
};

export default MainScreen;


const BodyWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
    text-align: center;
`;
const Body = styled.div`
    width: 100%;

`;
